/**
* @prop --cbp-pagination-color: var(--cbp-color-text-darkest);
* @prop --cbp-pagination-color-dark: var(--cbp-color-text-lightest);
 */
:root {
  --cbp-pagination-color: var(--cbp-color-text-darkest);
  --cbp-pagination-color-dark: var(--cbp-color-text-lightest);
}

/* 
 * Dark Mode - display dark design based on mode or context
 */
 [data-cbp-theme=light] cbp-pagination[context*=dark],
 [data-cbp-theme=dark] cbp-pagination:not([context=dark-inverts]):not([context=light-always]) {
  --cbp-pagination-color: var(--cbp-pagination-color-dark) !important;
 }


cbp-pagination {
  --cbp-form-field-margin-bottom: 0;
  
  display: flex;
  align-items: center;
  gap: var(--cbp-space-2x);
  color: var(--cbp-pagination-color);

  [slot=cbp-pagination-items-per-page],
  [slot=cbp-pagination-pages] {
    label {
      @include visuallyHidden //see global/styles/index.scss for declaration
    }
  }

  .cbp-pagination-showing-text {
    flex-grow: 1;
    font-style: italic;
  }

  // This is a loose coupling, but should work based on the expected markup in the pattern/story
  [slot=cbp-pagination-pages] cbp-button {
    // attached buttons should match the input border
    --cbp-button-color-bg: var(--cbp-form-field-color-border);
    --cbp-button-color-bg-dark: var(--cbp-form-field-color-border-dark);
  }

}

@media (max-width: 30rem) {
  cbp-pagination {
    [slot=cbp-pagination-items-per-page] {
      display: none;
    }
  }
}